import awsdk from 'awsdk';

// Disclaimer
// LegalEntity
// SpecialtyLegalEntity

export const DisclaimerEntityType = awsdk.AWSDKDisclaimerEntityType;
export type DisclaimerEntityType = typeof DisclaimerEntityType;
